<template>
  <div class="body">
    <van-nav-bar title="订单评价" left-text left-arrow @click-left="onClickLeft" class="topNav"/>
    <div class="content">
      <div v-for="(items,indexs) in order" :key="indexs" class="appwrap">
        <div class="infoWrap">
          <div class="infoLeft">
            <img :src="items.img | thumbnail(150,150)">
          </div>
          <div class="infoRight">
            <p class="orderName">{{items.name}}</p>
            <p class="orderPrice">{{items.price}}</p>
          </div>
        </div>
        <div class="scoreWrap">
          <p
            :style="items.score==item.cont ? 'color:'+item.color+';background:'+item.bg : '' "
            v-for="(item,index) in score"
            :key="index"
            @click="changeScore(indexs,item.cont)"
          >
            <i :class="'iconfont '+item.icon" :style="'background:'+item.bg"/>
            {{item.name}}
          </p>
        </div>
        <textarea class="appText" placeholder="请输入评论内容" v-model="items.txt"/>
        <div class="postImg" @click="changIndexs(indexs)">
          <form>
            <van-uploader :after-read="onAdd" class="img" :before-read="beforeread">
              <div class="imgList" v-for="(item,index) in items.fileList" :key="index">
                <i class="iconfont icon-guanbi3" @click="del(indexs,index)"/>
                <img :src="item.img | thumbnail(180,180)">
              </div>
              <i class="iconfont icon-plus postIcon"/>
            </van-uploader>
          </form>
        </div>
      </div>
      <button class="sub" @click="sub()">确认提交</button>
    </div>
  </div>
</template>

<script>
import * as qiNiu from "qiniu-js";
import HtmlImageCompress from "@/utils/HtmlImageCompress";
import { OrderCommit, Commit, UploadImg } from "../../apis/https.js";
import { getLocalStorage } from "../../utils/storage.js";
import { Uploader, Icon } from "vant";
import Vue from "vue";
Vue.use(Uploader).use(Icon);
// import { Checkbox, CheckboxGroup } from "vant";
// import Vue from "vue";
// Vue.use(Checkbox).use(CheckboxGroup);
export default {
  components: {},
  data() {
    return {
      hasData: false,
      id: "",
      order: [],
      fileList: [],
      queueUpload: [],
      score: [
        {
          name: "好评",
          bg: "#ff4544",
          color: "#fff",
          icon: "icon-haoping",
          cont: "10"
        },
        {
          name: "中评",
          bg: "#fcb500",
          color: "#fff",
          icon: "icon-zhongping",
          cont: "5"
        },
        {
          name: "差评",
          bg: "#9b9b9b",
          color: "#fff",
          icon: "icon-chaping1",
          cont: "0"
        }
      ],
      active: 0
    };
  },
  created() {},
  activated() {
    this.id = this.$route.query.id;
    this.OrderCommit(this.id);
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    OrderCommit(id) {
      OrderCommit(id, getLocalStorage("login_token")).then(res => {
        console.log(res);
        let data = res.data.goodsList;
        let result = [];
        for (let i in data) {
          result.push({
            id: data[i].goods_id,
            oid: data[i].order_goods_id,
            img: data[i].image.file_path,
            name: data[i].goods_name,
            price: data[i].total_price,
            score: "10",
            fileList: [],
            txt: ""
          });
        }
        this.order = result;
      });
    },
    onAdd(file) {
      this.$toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true, // 禁用背景点击
        loadingType: "spinner",
        message: "上传中"
      });
      let htmlImageCompress = new HtmlImageCompress(file.content, {
        width: 1080,
        quality: 0.7
      });
      htmlImageCompress.then(result => {
        let fd = new FormData();
        fd.append("iFile", this.dataURLtoFile(result.base64));
        fd.append("token", getLocalStorage("login_token"));
        fd.append("wxapp_id", 10003); //这里上传的是一个图片文件，以base64传递
        UploadImg(fd).then(res => {
          this.$toast.clear();
          this.order[this.active].fileList.push({
            img: res.data.file_path,
            id: res.data.file_id
          });
        });
      });
    },
    beforeread() {
      if (this.fileList.length >= 6) {
        this.$toast("最多可以上传6张图片");
        return false;
      }
      return true;
    },
    del(indexs, index) {
      console.log(this.order[indexs].fileList[index]);
      this.order[indexs].fileList.splice(index, 1);
    },
    changeScore(indexs, index) {
      console.log(this.order[indexs]);
      this.order[indexs].score = index;
    },
    changIndexs(index) {
      this.active = index;
    },
    sub() {
      let formData = [];
      for (let i in this.order) {
        let img = [];
        let uploaded = [];
        for (let j in this.order[i].fileList) {
          img.push(this.order[i].fileList[j].img);
          uploaded.push(this.order[i].fileList[j].id);
        }
        formData.push({
          goods_id: this.order[i].id,
          order_goods_id: this.order[i].oid,
          score: this.order[i].score,
          content: this.order[i].txt,
          image_list: img,
          uploaded: uploaded
        });
      }
      Commit(
        this.id,
        JSON.stringify(formData),
        getLocalStorage("login_token")
      ).then(res => {
        this.$toast("上传成功");
        this.$router.replace("/pages/order/index?index=4");
      });
      // {
      //   order_id: 10110;
      //   formData: [
      //     {
      //       goods_id: 10429,
      //       order_goods_id: 10098,
      //       score: 10,
      //       content: "1",
      //       image_list: [
      //         "http://tmp/wx327ab51407e5f587.o6zAJswPlD2IgxKb0Ydn8-MJuBcU.r89gnsTPKvSi3fdbf6c1f98f608cb6841d0d9ea341f7.png",
      //         "http://tmp/wx327ab51407e5f587.o6zAJswPlD2IgxKb0Ydn8-MJuBcU.rgAUHL3C1Wxo755e0d6f179e53ac6bb018f26d7a84f9.png"
      //       ],
      //       uploaded: ["", ""]
      //     }
      //   ];
      //   wxapp_id: 10001;
      //   token: ed4bbb9dae2287b1ef9d326efc733ec0;
      // }
    },
    dataURLtoFile(dataurl, filename = "file") {
      let arr = dataurl.split(",");
      let mime = arr[0].match(/:(.*?);/)[1];
      let suffix = mime.split("/")[1];
      let bstr = atob(arr[1]);
      let n = bstr.length;
      let u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], `${filename}.${suffix}`, {
        type: mime
      });
    }
  }
};
</script>
<style lang="less" scoped>
@import url("../../style/skin.less");
.body {
  background: @background;
  min-height: 100vh;
  overflow: hidden;
  .topNav {
    position: fixed;
    width: 100%;
    top: 0px;
    i {
      color: #323233 !important;
    }
  }
  .content {
    margin-top: 46px;
    margin-bottom: 50px;
    .appwrap {
      background: @white;
      margin-bottom: 10px;
      padding: 10px;
    }
    .infoWrap {
      display: flex;
      padding: 10px 0px;
      .infoLeft {
        width: 75px;
        height: 75px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .infoRight {
        flex: 1;
        max-width: calc(100% - 75px);
        padding-left: 10px;
        padding-top: 5px;
        .orderName {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          font-size: 15px;
          height: 30px;
          line-height: 30px;
        }
        .orderPrice {
          font-size: 14px;
          height: 30px;
          line-height: 30px;
        }
      }
    }
    .scoreWrap {
      margin: 0px auto;
      overflow: hidden;
      width: 280px;
      padding: 5px 0px;
      p {
        float: left;
        font-size: 14px;
        width: 80px;
        height: 30px;
        line-height: 30px;
        border-radius: 15px;
        margin-left: 20px;
        color: @darkP;
        text-align: left;
        i {
          display: inline-block;
          width: 30px;
          height: 30px;
          border-radius: 15px;
          text-align: center;
          line-height: 30px;
          color: @white;
          margin-right: 10px;
        }
      }
      p:first-child {
        margin-left: 0px;
      }
    }
    .appText {
      width: 100%;
      height: 110px;
      padding: 6px;
      border: 1px solid #e8e8e8;
      border-radius: 4px;
      box-sizing: border-box;
      resize: none;
      font-size: 12px;
    }
    .postImg {
      width: 100%;
      .img {
        display: flex;
        flex-wrap: wrap;
        .imgList {
          position: relative;
          margin-right: 20px;
          margin-bottom: 10px;
          i {
            position: absolute;
            top: -10px;
            right: -10px;
            width: 20px;
            height: 20px;
            text-align: center;
            line-height: 20px;
            color: @white;
            background: @red;
            border-radius: 10px;
            z-index: 2;
          }
          img {
            width: 90px;
            height: 90px;
          }
        }
        .postIcon {
          width: 90px;
          height: 90px;
          font-size: 80px;
          border: 1px dashed @lightP;
          color: @lightP;
          display: block;
          line-height: 90px;
          text-align: center;
        }
      }
    }
    .sub {
      position: fixed;
      height: 50px;
      bottom: 0px;
      width: 100%;
      font-size: 16px;
      background: @btn;
      color: @white;
      border: 0px;
    }
  }
}

@media (device-height: 812px) and (device-width: 375px) {
  .content {
    padding-bottom: 0.8rem !important;
  }
  .sub {
    padding-bottom: 0.8rem;
  }
}
</style>